var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleOfficial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_1331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8442 8.18429C15.8442 7.64047 15.8001 7.09371 15.706 6.55872H8.16016V9.63937H12.4813C12.302 10.6329 11.7258 11.5119 10.8822 12.0704V14.0693H13.4602C14.9741 12.6759 15.8442 10.6182 15.8442 8.18429Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15974 16.0006C10.3174 16.0006 12.137 15.2922 13.4627 14.0693L10.8847 12.0704C10.1675 12.5584 9.2415 12.8347 8.16268 12.8347C6.0756 12.8347 4.30598 11.4266 3.67104 9.53357H1.01074V11.5942C2.36882 14.2956 5.13494 16.0006 8.15974 16.0006Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66852 9.53356C3.33341 8.53999 3.33341 7.46411 3.66852 6.47054V4.40991H1.01116C-0.123511 6.67043 -0.123511 9.33367 1.01116 11.5942L3.66852 9.53356Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15974 3.16644C9.30029 3.1488 10.4026 3.57798 11.2286 4.36578L13.5127 2.08174C12.0664 0.72367 10.1469 -0.0229773 8.15974 0.000539111C5.13494 0.000539111 2.36882 1.70548 1.01074 4.40987L3.6681 6.4705C4.3001 4.57449 6.07266 3.16644 8.15974 3.16644Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_1331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleOfficial);
export default __webpack_public_path__ + "static/media/Google-Official.700b4cf7433343f1d1eba7cd2519beb4.svg";
export { ForwardRef as ReactComponent };